import { inject } from '@angular/core';
import { type CanActivateChildFn, Router } from '@angular/router';

import { DashboardAccessService } from '@core/analytics-api/dashboard-access.service';
import { findDashboard } from './dashboard-registry';

/** Недоступный по `GET /dashboards` дашборд по прямой ссылке не открывается — назад на главную. */
export const dashboardAccessGuard: CanActivateChildFn = async (_route, state) => {
  const access = inject(DashboardAccessService);
  const home = inject(Router).createUrlTree(['/']);
  const entry = findDashboard(state.url);

  if (entry === undefined) {
    return true;
  }

  return access.allows(entry.apiKey, await access.ensure()) ? true : home;
};
